<template>
  <div>
    <a-card
      title="查询"
      size="small"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          创建时间
          <a-range-picker
            v-model:value="searchForm.date"
            style="width: 250px"
            :placeholder="['', '']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>
        <a-form-item>
          任务状态
          <a-select
            style="width: 250px"
            v-model:value="searchForm.status"
            :labelInValue="true"
          >
            <a-select-option value="0">待处理</a-select-option>
            <a-select-option value="1">已处理</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          创建人
          <!-- @change="handlerChange" -->
          <a-select
            style="width: 250px"
            :labelInValue="true"
            v-model:value="searchForm.createname"
          >
            <a-select-option v-for="(c, index) in createList" :key="index">
              {{ c }}
            </a-select-option>
          </a-select>
          <!-- input search -->
          <!-- <a-input
            style="width: 250px"
            @keyup.enter.native="searchAction()"
            v-model:value="searchForm.createname"
          /> -->
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <!-- table -->
    <a-table
      bordered
      :scroll="{ x: 1300 }"
      :dataSource="list"
      :pagination="false"
      :columns="columns"
      style="word-break: break-all"
      :loading="loading"
      :rowKey="
        (record, index) => {
          return index;
        }
      "
    >
      <template v-slot:increase="{ text, record, index }">{{
        index + 1
      }}</template>
      <template v-slot:disposeStatus="{ text, record }">
        {{ record.status == "0" ? "待处理" : "已处理" }}
      </template>
      <template v-slot:disposePrint="{ text, record }">
        {{ record.status == "0" ? "待打印" : "已打印" }}
      </template>
      <template v-slot:operation="{ text, record }">
        <a-button type="primary" @click="goDetail(record)"> 详情 </a-button>
      </template>
      <!-- 增加内容 -->
      <template #orderType="{ text, record, index }"> 订单类型 </template>
      <template #sellMoney="{ text, record, index }">
        客票实际销售金额
      </template>
      <template #printMoney="{ text, record, index }">行程单打印金额</template>
      <template #billLink="{ text, record, index }">差额发票链接</template>
    </a-table>
  </div>
  <df-pagination :model="pageObj"></df-pagination>
</template>

<script>
import orderApi from "@axios/order";
import { reactive, ref, provide, resolveComponent } from "vue";
import { useRouter } from "vue-router";
export default {
  setup() {
    let reset = () => {
      searchForm.status = "";
      searchForm.createname = "";
      searchForm.date = [];
    };
    let createList = ref([]);
    let add = () => {
      orderApi.getCreateList().then((res) => {
        createList.value = res;
      });
    };
    add();
    const router = useRouter();
    //跳转到机票打印页,传递taskid & taskcode
    let goDetail = (record) => {
      router.push({
        name: "orderPaint",
        params: {
          id: JSON.stringify(record.taskid),
          taskcode: record.taskcode,
          // record: JSON.stringify(record.taskid),
          // taskcode: JSON.stringify(record.taskcode),
        },
      });
    };
    let loading = ref(false);
    let searchForm = reactive({
      date: [],
      status: "",
      createname: "",
    });
    let searchParams = reactive({
      date: [],
      status: "",
      createname: "",
    });

    //分页
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    let list = ref([]);
    let searchAction = () => {
      searchParams.date = searchForm.date;
      searchParams.status = searchForm.status;
      searchParams.createname = searchForm.createname;
      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };
    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);
    let getList = async () => {
      loading.value = true;
      let params = {
        status: parseInt(searchParams.status.key),
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
        createname: searchParams.createname.label,
      };
      if (searchParams.date.length) {
        params.taskBeginTime = searchParams.date[0];
        params.taskEndTime = searchParams.date[1];
      }
      await orderApi.getOrderMsg(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        //过滤掉select状态为已处理的数据
        if (searchParams.status.key == 0) {
          list.value = res.data.filter((item) => item.status == false);
        } else if (searchParams.status.key == 1) {
          list.value = res.data.filter((item) => item.status == true);
        } else {
          list.value = res.data;
        }
      });
    };
    getList();
    return {
      reset,
      // handlerChange,
      createList,
      add,
      loading,
      onShowSizeChange,
      pageChange,
      pageObj,
      goDetail,
      list,
      searchAction,
      searchForm,
      searchParams,
      columns: [
        {
          title: "",

          width: 60,

          align: "center",

          slots: {
            customRender: "increase",
          },
        },
        {
          title: "任务号",
          align: "center",
          dataIndex: "taskcode",
          key: "taskcode",
          width: 200,
        },
        {
          title: "票数",
          align: "center",
          dataIndex: "ticketnum",
          key: "ticketnum",
          width: 100,
        },
        {
          title: "创建人",
          dataIndex: "createname",
          align: "center",
          key: "createname",
          width: 200,
        },
        {
          title: "创建时间",
          dataIndex: "createtime",
          width: 200,
          align: "center",
          key: "createtime",
        },
        {
          title: "处理状态",
          dataIndex: "status",
          align: "center",
          width: 200,
          slots: {
            customRender: "disposePrint",
          },
        },
        {
          title: "发送状态",
          dataIndex: "status",
          align: "center",
          width: 200,
          slots: {
            customRender: "disposeStatus",
          },
        },
        {
          title: "处理时间",
          dataIndex: "handletime",
          align: "center",
          width: 200,
          key: "handletime",
        },
        {
          title: "订单类型",
          align: "center",
          width: 200,
          slots: {
            customRender: "orderType",
          },
        },
        {
          title: "客票实际销售金额",
          align: "center",
          width: 200,
          slots: {
            customRender: "sellMoney",
          },
        },
        {
          title: "行程单打印金额",
          align: "center",
          width: 200,
          slots: {
            customRender: "printMoney",
          },
        },
        {
          title: "差额发票链接",
          align: "center",
          width: 200,
          slots: {
            customRender: "billLink",
          },
        },
        {
          title: "操作",
          align: "center",
          dataIndex: "operation",
          key: "operation",
          width: 220,
          slots: { customRender: "operation" },
        },
      ],
    };
  },
};
</script>

<style>
</style>